'use client';

import { Section, SectionHeading } from '@/components/ui/Section';
import { CATEGORY_LABELS, getProductsByCategory, type ProductCategory } from '@/data/products';

import { ProductCard } from './ProductCard';

export interface PricingGridProps {
  id?: string;
  eyebrow?: string;
  title?: string;
  description?: string;
  categories?: ProductCategory[];
  tone?: 'default' | 'raised';
}

export function PricingGrid({
  id = 'pricing',
  eyebrow = 'Models & pricing',
  title = 'Choose the model that fits your business',
  description = 'Shipping is quoted separately for every model and confirmed before you pay. The SPK2GO app, configuration and installation are always included at no cost.',
  categories = ['tablet', 'cabinet', 'app'],
  tone = 'default',
}: PricingGridProps) {
  return (
    <Section id={id} tone={tone}>
      <SectionHeading eyebrow={eyebrow} title={title} description={description} />

      <div className="mt-14 flex flex-col gap-14">
        {categories.map((category) => {
          const products = getProductsByCategory(category);
          if (products.length === 0) return null;

          return (
            <div key={category} className="flex flex-col gap-6">
              <h3 className="text-content-subtle border-line/70 border-b pb-3 text-sm font-semibold tracking-[0.24em] uppercase">
                {CATEGORY_LABELS[category]}
              </h3>
              <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
                {products.map((product) => (
                  <ProductCard key={product.id} product={product} orderable={product.category !== 'app'} />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
}
